import { render } from "./ScoreImport.vue?vue&type=template&id=f717d996&scoped=true&ts=true"
import script from "./scoreImportHelper.ts?vue&type=script&lang=ts"
export * from "./scoreImportHelper.ts?vue&type=script&lang=ts"

import "./ScoreImport.vue?vue&type=style&index=0&id=f717d996&scoped=true&lang=css"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f717d996"]])

export default __exports__